import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          热门排行
        </h2>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.id}
              href="#updates"
              className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
              </div>

              <span className="px-2.5 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                {item.tag}
              </span>

              <span className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.heat}</span>

              <span className="text-xs text-foreground-500 whitespace-nowrap hidden sm:inline">{item.status}</span>

              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-s-fill text-accent-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-s-fill text-foreground-400 text-sm"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}